import { useContainer } from '../../useContainer';
import { OrganizationApi, ToastStateHandler } from '../../../api';
import { dispatch } from '../../../store';
import { deleteBranch } from '../../../store/slices/branch.slice';
import { useTranslation } from '../../useTranslation';

const useHttpDeleteBranch = () => {
    const { t } = useTranslation('newNotifications');
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (id: string) => {
        const { exec, abort } = organizationApi.deleteBranch({
            params: { id },
            onSuccess: () => {
                dispatch(deleteBranch(id));
                toastHandler.push('success', t('branch.deleteBranchTitle'), t('branch.deleteBranchMessage_Success'));
            },
            onError: error => {
                toastHandler.push('error', t('branch.deleteBranchTitle'), t('branch.deleteBranchMessage_Failed'));
                console.log(`Error occured while deleting branch: ${error}`);
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpDeleteBranch;
